import api from "../services/api";

import { IProduto, ISearchRequest, ISearchResponse } from "../interfaces";

export interface IProdutoListModel {
    id?: string;
    codigo: string;
    categoria?: string;
    nome: string;
    valor: number;
    status: number;
}

interface IProdutoInsertResponse {
    produto: IProduto;
    message: string;
}

class ProdutoRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IProdutoListModel>> => {

        const response = await api.get<ISearchResponse<IProdutoListModel>>("produto", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public Insert = async ({ codigo, nome, valor, status, categoriaId }: IProduto): Promise<IProdutoInsertResponse> => {
        const response = await api.post<IProdutoInsertResponse>("produto", { codigo, nome, valor, status, categoriaId });

        return response.data;
    }
}

const produtoRepository = new ProdutoRepository();
export default produtoRepository;
